import { environment } from '../../environment/environment';
import { headersAutorization } from '../../helpers/headerAutorization';
import http from '../../helpers/http';

const url = environment.apiUrl;
export const getSpace = () => {
  const headers = headersAutorization();
  return http.get(`${url}/users/space`, headers);
};
